<template>
  <div class="rf-mapa-pagina">
    <p v-if="error" class="rf-estado rf-estado--error">{{ error }}</p>
    <template v-else-if="p">
      <div class="rf-cabecera">
        <h1 class="rf-titulo-sans">{{ p.nombre }}</h1>
        <p class="rf-frase">{{ p.descripcion }}</p>
      </div>
      <mapa-lotes
        :proyecto="p"
        :whatsapp-numero="sitio.whatsapp_numero"
        :whatsapp-mensaje="sitio.whatsapp_mensaje"
      />
      <p style="margin-top: 24px; text-align: center">
        <a :href="`/landing-refugios/${p.id}`" class="rf-btn">← Volver al proyecto</a>
      </p>
    </template>
  </div>
</template>

<script>
import MapaLotes from './MapaLotes.vue';
import { obtenerProyecto } from '@/services/refugiosApi';

export default {
  name: 'RfMapa',
  components: { MapaLotes },
  props: {
    proyecto: { type: Number, required: true },
    sitio: { type: Object, required: true },
  },
  data() {
    return { p: null, error: '' };
  },
  async mounted() {
    try {
      this.p = await obtenerProyecto(this.proyecto);
    } catch (e) {
      this.error = 'No se pudo cargar el proyecto. Intenta de nuevo en un momento.';
    }
  },
};
</script>
